import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSelect, InputNumber, InputSwitch } from '../../components';
import BaseCopy from '../base/base-copy.component'; 
import Model from './region-model';  //editable..

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class RegionCopy extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
     
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        const typeCaption = Model.optionType.filter((d: any) => d.name === this.state.datarow.type)?.[0]?.caption;

        return (
            //editable..
            <BaseCopy history={this.props.history} caption={'Copy ' +typeCaption}
                model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                {this.state.datarow.type === 'village' &&
                <>
                <InputNumber name='zipcode' label='Zip Code' value={this.state.datarow.zipcode} error={this.state.errors?.zipcode} onChange={this.onChange} />
                <Input name='code' label='Region Code' value={this.state.datarow.code} error={this.state.errors?.code} onChange={this.onChange} />
                <InputNumber name='latitude' label='Latitude' value={this.state.datarow.latitude} error={this.state.errors?.latitude} onChange={this.onChange} />
                <InputNumber name='longitude' label='Longitude' value={this.state.datarow.longitude} error={this.state.errors?.longitude} onChange={this.onChange} />
                <InputNumber name='elevation' label='Elevation' value={this.state.datarow.elevation} error={this.state.errors?.elevation} onChange={this.onChange} />
                </>
                }
                {this.state.datarow.parent &&
                <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                }             
            </BaseCopy>
        );
    }
}